import styled from "styled-components";

export const MoreInfo = styled.div`
  border: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;

  span {
    font-size: 1.6rem;
    font-weight: 600;
  }
`;

export const MoreContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
`;

export const MoreDetail = styled.div`
  color: ${(props) => props.theme.colors.primary};
  font-size: 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: 33%;
`;

export const MoreValue = styled.div`
  color: ${(props) => props.theme.colors.black};
  font-size: 1.6rem;
  font-weight: 750;
`;
